import { NavTabs } from '@shared/tabs/NavTabs';
import { RateCards } from './RateCards/RateCards';
import { Requirements } from './Requirements/Requirements';

interface ILenderEditorTabsProps {
  lenderId: string;
  loading?: boolean;
}

export type ILenderEditorTabProps = ILenderEditorTabsProps;

export const LenderEditorTabs = ({ lenderId, loading }: ILenderEditorTabsProps) => {
  const props: ILenderEditorTabsProps = {
    lenderId,
  };

  const withPlaceholder = (cmp: JSX.Element) => (!lenderId ? 'Please select lender above' : cmp);

  const tabs = [
    {
      name: 'Requirements',
      component: withPlaceholder(<Requirements {...props} />),
    },
    {
      name: 'Rate Cards',
      component: withPlaceholder(<RateCards {...props} />),
    },
  ];

  return <NavTabs data={tabs} loading={!!loading} />;
};
